import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var WDialog = /*#__PURE__*/function (_Vue) {
  function WDialog() {
    var _this;
    _classCallCheck(this, WDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WDialog, [].concat(args));
    _defineProperty(_this, "title", void 0);
    _defineProperty(_this, "width", void 0);
    _defineProperty(_this, "customClass", void 0);
    _defineProperty(_this, "center", void 0);
    _defineProperty(_this, "closeOnOutsideClick", void 0);
    _defineProperty(_this, "showClose", void 0);
    return _this;
  }
  _inherits(WDialog, _Vue);
  return _createClass(WDialog, [{
    key: "emitCloseEvent",
    value: function emitCloseEvent() {
      this.$emit("dialogClose");
    }
  }]);
}(Vue);
__decorate([Prop({
  default: ''
})], WDialog.prototype, "title", void 0);
__decorate([Prop({
  default: '560px'
})], WDialog.prototype, "width", void 0);
__decorate([Prop({
  default: ''
})], WDialog.prototype, "customClass", void 0);
__decorate([Prop({
  default: true
})], WDialog.prototype, "center", void 0);
__decorate([Prop({
  default: false
})], WDialog.prototype, "closeOnOutsideClick", void 0);
__decorate([Prop({
  default: true
})], WDialog.prototype, "showClose", void 0);
WDialog = __decorate([Options({
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      isVisible: false
    };
  },
  watch: {
    visible: function visible() {
      this.isVisible = this.visible;
    }
  }
})], WDialog);
export default WDialog;